<template>
  <section>
    <el-row style="min-width:1100px;padding:15px;margin-bottom:30px">
      <!-- 有问题 -->
      <el-col :span="6">
        <el-input
          @clear="getList"
          @keyup.enter.native="getList"
          ref="input"
          class="search"
          v-model="pdata.kw"
          clearable
          placeholder="请输入小程序名称"
          :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
        ></el-input>
      </el-col>
      <el-col :span="6" :offset="12">
        <div style="float:right;min-width:100px">
          <el-button size="small" type="primary" @click="add">新增</el-button>
          <el-button size="small" type="info" @click="delate">删除</el-button>
        </div>
      </el-col>
    </el-row>
    <el-table :data="list" @selection-change="select">
      <el-table-column type="selection"></el-table-column>
      <el-table-column label="小程序名称" prop="name">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="SDK版本号" prop="version"></el-table-column>
      <el-table-column label="更新时间" prop="u_time"></el-table-column>
    </el-table>
    <el-dialog :title="isAdd?'新增投放':'编辑投放'" :visible.sync="addDialog"  width="500px" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="小程序名称" label-width="120px">
          <searchApp @getid="res=>{form.issued_app_id=res}" compare="name" :pholder="form.name"></searchApp>
        </el-form-item>
        <el-form-item label="SDK版本号" label-width="120px">
          <searchApp @getid="res=>{form.version_id=res}" compare="version" :pholder="form.version"></searchApp>
        </el-form-item>
        <el-form-item label="投放时间" label-width="120px">
          <el-date-picker
            v-model="form.u_time"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
            value-format="yyyy-MM-dd hh:mm"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { svlist, saddsdk, sdkstatus, seditsdk, svs } from "../../api/api";
export default {
  data() {
    return {
      applist: [],
      list: [],
      pdata: {
        page: 1,
        perpage: 20,
        kw: ""
      },
      maxPage: 1,
      addDialog: false,
      inputKW: "",
      form: {
        serving_id: "",
        issued_app_id: "",
        version_id: "",
        u_time: ""
      },
      isAdd: true
    };
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      svlist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.list = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },

    submitAdd() {
      if (this.isAdd) {
        if (this.form.issued_app_id && this.form.version_id) {
          saddsdk(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.getList();
              this.addDialog = false;
              this.form.issued_app_id = "";
              this.form.version_id = "";
            }
          });
        }
      } else {
        this.$prompt("请输入编辑原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: "内容不能为空"
        }).then(({ value }) => {
          this.form.log = value;
          seditsdk(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.getList();
              this.addDialog = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        });
      }
    },
    delate() {
      var serving_id = "测";
      this.chooseList.forEach(v => {
        serving_id += "," + v.id;
      });
      var p = {
        serving_id: serving_id.slice(2),
        status: -1
      };
      sdkstatus(p, this.$cookie.getCookie("login")).then(res => {
        this.getList();
      });
    },
    add() {
      this.isAdd = true;
      this.form = { issued_app_id: "", version_id: "", u_time: "" };
      this.addDialog = true;
    },
    edit(s) {
      this.isAdd = false;
      svs(s.id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.form.serving_id = s.id;
        }
      });
      this.addDialog = true;
    },
    select(s) {
      this.chooseList = s;
    }
  },
  mounted() {
    this.getList();
    this.applist = this.$store.applist;
  }
};
</script>




// WEBPACK FOOTER //
// sdkVersion.vue?2a16b734